import React from 'react';
import { Group, Rect, Image } from 'react-konva';
import Score from './Score';
import { GetScoreDefn, getScoreText, GetTextColor } from 'utils/Global';
import EAutoScoreType from 'enums/EAutoScoreType';
import EColors from 'enums/EColors';
import { ScoresOfWellDropsDTO } from 'business/models/Models';
import DisputeIcon from 'Icons/Exp_Sidebar/DisputeIcon.svg';
import { getScoreToolTip } from './utils';
import { RMSvgIconImage } from 'components/customComponents/CommonComponents/RMSvgIcon';

const ignoredAutoScoreIcon = RMSvgIconImage({ name: 'EyeSlash', fill: '#dc0100' });

export default function ScoreViewWell(props: any) {
  function getScoresComponents() {
    if (GetScoreDefn() === null) {
      return null;
    }
    const scoreComponents = [];

    const isDisputed = props.scoresOfWellDrops.some((el) => el.isDisputed === true);
    let scoreHeight = props.height / props.scoresOfWellDrops.length;
    if (isDisputed) {
      scoreHeight = props.height / (props.scoresOfWellDrops.length + 1);
      const leftMargin = props.width / 2 - scoreHeight / 2;
      scoreComponents.push(
        <Group id="scoreviewwell-component">
          <Rect
            id="scoreviewwell-component-rect"
            x={props.x}
            y={props.y}
            width={props.width}
            height={scoreHeight}
            fill={'rgba(164, 0, 0, 1)'}
          />

          <Image
            id="scoreviewwell-component-img"
            x={props.x + leftMargin}
            y={props.y}
            width={scoreHeight}
            height={scoreHeight}
            image={props.icon}
          />
        </Group>,
      );
    }

    let topMargin = 0;
    if (isDisputed) {
      topMargin = scoreHeight;
    }
    for (let i = 0; i < props.scoresOfWellDrops.length; i++) {
      const wellDropScore: ScoresOfWellDropsDTO = props.scoresOfWellDrops[i];
      const scoreY = props.y + scoreHeight * i + topMargin;
      if (wellDropScore.isUVIndicator) {
        const indicatorColor = `rgb(${wellDropScore.colorRGB})`;
        scoreComponents.push(
          <Group key={`scoreviewwell-uv-${i}`}>
            <Score
              id="scoreviewwell-score-component"
              x={props.x}
              y={scoreY}
              width={props.width}
              height={scoreHeight}
              color={indicatorColor}
              totalScores={props.scoresOfWellDrops.length}
              Scores={wellDropScore.scoreName}
              isDisputed={false}
              textcolor={EColors.White}
              scoreType={wellDropScore.scoreType}
              scale={props.scale}
              toolTipText={getScoreToolTip(wellDropScore, null)}
            />
            {wellDropScore.isAutoScoreIgnored && (
              <Image
                id={`scoreviewwell-ignored-autoscore-icon-${i}`}
                x={props.x / (props.scale || 1)}
                y={scoreY / (props.scale || 1)}
                width={props.width / (props.scale || 1)}
                height={scoreHeight / (props.scale || 1)}
                image={ignoredAutoScoreIcon}
              />
            )}
          </Group>,
        );
        continue;
      }
      const score = GetScoreDefn().find(
        (score) => score.wellDropScoreId === props.scoresOfWellDrops[i].wellDropScoreId,
      );
      const color = `rgb(${score.color})`;

      const disputeIcon = new window.Image();
      disputeIcon.src = DisputeIcon;

      scoreComponents.push(
        <Group key={`scoreviewwell-score-${i}`}>
          <Score
            id="scoreviewwell-score-component"
            x={props.x}
            y={scoreY}
            width={props.width}
            height={scoreHeight}
            color={color}
            totalScores={props.scoresOfWellDrops.length}
            Scores={getScoreText(wellDropScore, score)}
            isDisputed={wellDropScore.isDisputed}
            textcolor={
              wellDropScore.autoScoreType === EAutoScoreType.IP
                ? EColors.White
                : GetTextColor(score.color)
            }
            scoreType={wellDropScore.scoreType}
            scale={props.scale}
            toolTipText={getScoreToolTip(wellDropScore, score)}
          />
          {wellDropScore.isAutoScoreIgnored && (
            <Image
              id={`scoreviewwell-ignored-autoscore-icon-${i}`}
              x={props.x / (props.scale || 1)}
              y={scoreY / (props.scale || 1)}
              width={props.width / (props.scale || 1)}
              height={scoreHeight / (props.scale || 1)}
              image={ignoredAutoScoreIcon}
            />
          )}
        </Group>,
      );
    }
    return scoreComponents;
  }
  return <Group id="scoreviewwell-wrapper">{getScoresComponents()}</Group>;
}
